/* //* Package imports */
import React from 'react'
import axios from 'axios'
import { ToastContainer } from 'react-toastify'

/* //* Component imports */
import PaginatedDataTable from "../common/paginatedDataTable"
import CreateFormModal from "../common/CreateFormModal"

/* //* Service imports */
import {header} from '../common/cookieChecker'

/* //* URL imports */
import {getPartnerLeadList} from '../common/urls.js'

class LeadListing extends React.Component{

  constructor(props) {
    super(props);
    this.state = {
        show:false,
        show_modal:false,
        response:[],
        user_id:'',
        count: 0,
        pages: 0
    }
  }

  async componentDidMount(){
    axios.get(getPartnerLeadList(1, 10),header()).then((res) => {
        this.setState({show:true, response:res.data.data, pages: res.data.pages, count: res.data.count });
      }).catch(err => window.location.href = '/login');
  }

  getPageData = (page_num, page_size) => {
    axios.get(getPartnerLeadList(page_num, page_size),header()).then((res) => {
      this.setState({ show:true, response:res.data.data, pages: res.data.pages, count: res.data.count });
    }).catch(err => console.log(err));
  };

  render(){
    return <>
        {/* <div className="bg2 wrapper_listing"> */}
        <div className="col mt-2">
          <PaginatedDataTable
            response={this.state.response}
            onPageChange={this.getPageData}
            count={this.state.count}
            pages={this.state.pages} />
        </div>
        <div className="col mt-2 px-0">
          <CreateFormModal />
        </div>
        <ToastContainer/>
    </>
  }
}


export default LeadListing;
